import { Link } from 'react-router-dom';
import { siteNav, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-global-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl text-white">亚洲在线</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              亚洲最全在线服务平台，汇聚亚洲各地优质资源与内容，为您提供便捷、安全、高效的在线体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {siteNav.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category/entertainment" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">娱乐影音</Link></li>
              <li><Link to="/category/shopping" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">在线购物</Link></li>
              <li><Link to="/category/travel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">旅游出行</Link></li>
              <li><Link to="/category/tech" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">科技数码</Link></li>
              <li><Link to="/category/lifestyle" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">生活服务</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5 text-sm text-foreground-400">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                {siteInfo.email}
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                {siteInfo.phone}
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © 2026 亚洲在线 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}